import { render, staticRenderFns } from "./PdfFeature.vue?vue&type=template&id=57dae616&scoped=true"
import script from "./PdfFeature.vue?vue&type=script&lang=js"
export * from "./PdfFeature.vue?vue&type=script&lang=js"
import style0 from "./PdfFeature.vue?vue&type=style&index=0&id=57dae616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dae616",
  null
  
)

export default component.exports